import u, { useRef as n } from "react";
import { useStatefulRef as a } from "./useStatefulRef.js";
const R = (t, r = { isStateful: !0 }) => {
  const { isStateful: f } = r, s = a(), o = n(), e = f ? s : o;
  return u.useImperativeHandle(t, () => e.current), e;
};
export {
  R as useForwardedRef
};
